export const ERROR_CODES = {
	DUPLICATED_SESSION: {
		key: 'e=1',
		message: 'A duplicated session was detected. Logged out.',
	},
	DUPLICATED_SESSION_TAB: {
		key: 'e=2',
		message: 'A duplicated tab session was detected. Logged out.',
	},
};

